<ng-container *ngIf="cards$ | async as cards">
  <ng-container *ngIf="!forceLoader && !(isLoading$ | async); else loading">
    <h3>{{ 'checkoutProgress.shippingAddress' | cxTranslate }}</h3>
    <div class="eb-shipping-address__subHeading">
      {{ 'shippingAddress.subHeading' | cxTranslate }}
    </div>
    <div class="address-row">
      <eb-address-card
        *ngFor="let card of cards; let i = index"
        [fitToContainer]="true"
        [content]="card.card"
        [class.default]="card.address.id === (selectedAddress$ | async)?.id"
        class="eb-shipping-address__address-card"
        (click)="selectAddress(card.address)"
        (editCard)="editAddress(card.address)"
        (deleteCard)="deleteAddress(card.address)"
      ></eb-address-card>
      <eb-address-card
        [content]="getNewAddressCardContent()"
        (click)="newAddress()"
        [fitToContainer]="false"
        class="eb-shipping-address__new-address"
      >
      </eb-address-card>
    </div>

    <eb-checkout-step-buttons
      [disabled]="!(selectedAddress$ | async)?.id"
      (back)="back()"
      (next)="next()"
    >
    </eb-checkout-step-buttons>

    <eb-info-box icon="info-circle" [infoType]="'INFO'" class="eb-shipping-address__info-box">{{
      'shippingAddress.edit.infoBox' | cxTranslate
    }}</eb-info-box>
  </ng-container>

  <ng-template #loading>
    <eb-spinner class="eb-shipping-address__spinner"></eb-spinner>
  </ng-template>
</ng-container>
